import React from "react";
import { FaIcon } from "../../../lib/FaIcon";
import { gotoSearchPage } from "../../../pages/search/api/filterUrlMaker";
import { Nav } from "react-bootstrap";
import { useLocation } from "react-router";

export const SearchButton = ({ right, className = "fa-lg" }) => {
  const { pathname } = useLocation();
  const icon = pathname.includes("Search_Results") ? "fa-arrow-left" : "fa-search";

  return (
    <Nav.Link aria-label="Search button" className={right ? "ml-auto mr-0" : ""}>
      <FaIcon icon={"fa " + icon} onClick={gotoSearchPage} className={className} />
    </Nav.Link>
  );
};
